import { Record, Map } from "immutable";

import { QuestionAggregationType } from "./QuestionAggregation";

export type QuestionsAggregationType = QuestionAggregationType & {
  questions?: Map<string, QuestionAggregationType>;
};

export const defaultQuestionsAggregation: QuestionsAggregationType = {
  averageMark: undefined,
  marksTotal: undefined,
  questions: undefined
};

export default class QuestionsAggregation extends Record(
  defaultQuestionsAggregation
) {}

export { default as QuestionAggregation } from "./QuestionAggregation";
